import * as Sentry from "@sentry/react"
import { startTransition, useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../redux"
import { AppActions } from "../redux/appSlice"
import { checkCurrentUsage } from "../services"
import { firebaseAuth } from "../utils/firebase"

export function useUsageDetails() {
  const user = useAppSelector((state) => state.app.user)
  const dispatch = useAppDispatch()

  useEffect(() => {
    const fetchUsageDetails = async () => {
      startTransition(() => {
        dispatch(AppActions.updateShowStripeModal(false))
      })

      if (!user?.uid) {
        startTransition(() => {
          dispatch(AppActions.updateUsageDetailsLoading(false))
          dispatch(AppActions.resetUsageDetails())
        })
        return
      }

      if (!firebaseAuth?.currentUser) {
        return
      }

      if (
        user.subscriptionPlan === undefined &&
        user.subscriptionState === undefined
      ) {
        return
      }

      try {
        startTransition(() => {
          dispatch(AppActions.updateUsageDetailsLoading(true))
        })
        const usageDetails = await checkCurrentUsage(user.uid)
        startTransition(() => {
          dispatch(AppActions.updateUsageDetails(usageDetails))
        })
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : String(error)

        if (errorMessage.includes("not authenticated")) {
          return
        }

        console.error("Failed to check current usage:", error)
        Sentry.captureException(error, {
          tags: { hook: "useUsageDetails", operation: "check_current_usage" },
          user: { uid: user.uid },
        })
      } finally {
        startTransition(() => {
          dispatch(AppActions.updateUsageDetailsLoading(false))
        })
      }
    }

    fetchUsageDetails()
  }, [user, dispatch])
}
